import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_off"}/>
}
